

export default{
  state:{
    historial: null,
    today: null,

    medicamentosSendToday: [],
  },


  mutations : {

    setHistorialRecetas(state, newData){
      state.historial = newData 
    },

    setRecetasToday(state, newData){
      state.today = newData
    },

    setMedicamentosSendToday(state, newData){
      state.medicamentosSendToday = newData
    },
  }
}



